/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'shared';
const componentName = 'async-file-upload-with-upload-service';
const prefix = `${moduleName}.${componentName}`;

export const fileUploadedSuccessfullyHeader = `${prefix}.fileUploadedSuccessfullyHeader`;

export const ENGLISH = {
    [fileUploadedSuccessfullyHeader]: 'File uploaded successfully',
};
